<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Procedimentos cirúrgico"
    >
        <Form 
            :procedimentoCirurgico="procedimentoCirurgicoEdit"
            :regulador="regulador" 
            @procedimentoCirurgicoUpdate="handleProcedimentoCirurgicoUpdate"
        />

        <List
            :data="data"
            :regulador="regulador"
            @edit="handleEdit"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalRegulador: null,
        regulador: null,
        procedimentoCirurgicoEdit: null
    }),
    methods: {
        open(regulador) {

            this.originalRegulador = regulador
            this.regulador = this.clone(regulador)
            this.procedimentoCirurgicoEdit = null
            
            this.$refs.Modal.show()
        },
        save() {

            this.originalRegulador.procedimentosCirurgicos = this.regulador.procedimentosCirurgicos
            
            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        },
        handleEdit(procedimentoCirurgico) {

            this.procedimentoCirurgicoEdit = procedimentoCirurgico
        },
        handleProcedimentoCirurgicoUpdate(procedimentoCirurgico) {

            const index = this.regulador.procedimentosCirurgicos.findIndex(pc => pc.id === procedimentoCirurgico.id)
            if (index !== -1) {
                this.regulador.procedimentosCirurgicos.splice(index, 1, procedimentoCirurgico)
            }
            this.procedimentoCirurgicoEdit = null
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>